import { GradientText } from '@/components/GradientText';
import { Link } from '@/components/Link';
import { Text } from '@/components/Text';
import { AuthLayout } from '@/layouts/AuthLayout';
import i18n from '@/translations/config';
import { useTranslation } from 'react-i18next';

export const VerifyEmail = () => {
  const { t } = useTranslation();
  const lang = i18n.language;

  return (
    <AuthLayout
      title={t('verifyEmail:title')}
      welcomeText={t('verifyEmail:welcome-text')}
    >
      <div className="mx-auto max-w-lg text-center">
        <div className="mx-auto mb-4 size-12 text-sky-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
            />
          </svg>
        </div>
        <h2 className="mb-4 text-2xl font-bold text-gray-900">
          {t('verifyEmail:check-email')}
        </h2>
        <Text className="mb-6 text-gray-600">
          {t('verifyEmail:instructions')}
        </Text>
      </div>

      <Text className="mt-6 text-center text-sm text-gray-600">
        {t('verifyEmail:back-to-login')}{' '}
        <Link
          to={`/${lang}`}
          className="font-medium text-sky-600 hover:text-sky-800"
        >
          <GradientText>{t('verifyEmail:login-link')}</GradientText>
        </Link>
      </Text>
    </AuthLayout>
  );
};
